import beep from "../../assets/sounds/beep.mp3";
import React from "react";

export default function Beep () {
  return (
    <audio id="notificacao" preload="auto">
      <source src={beep} type="audio/mpeg" />
    </audio>
  )
}